import { clsx } from 'clsx'
import { Link } from 'react-router'

export interface BreadcrumbItemProps {
  href: string;
  children: string;
  isActive?: boolean;
  isConsumerSize?: boolean;
  className?: string;
  id?: string;
  textEllipsis?: boolean
}

export const BreadcrumbItem = ({
  href,
  children,
  isActive = false,
  className,
  id,
  textEllipsis = false
}: BreadcrumbItemProps) => (
  <li
    id={id}
    className={clsx(
      'md:text-body2 sm:text-body3-mobile py-px md:py-0 items-center max-w-full whitespace-nowrap',
      "last:after:content-none after:content-['/'] after:text-(--sp-breadcrumb-separator-color,var(--neutral-80)) dark:after:text-(--sp-breadcrumb-separator-color,var(--neutral-30)) after:mx-1.5",
      textEllipsis ? 'overflow-hidden text-ellipsis' : '',
      className
    )}
  >
    <Link
      to={href}
      className={clsx(
        isActive ? 'pointer-events-none text-(--sp-color-text-muted)' : 'text-(--sp-color-link) hover:text-(--sp-color-link-hover) hover:underline')}
      aria-disabled={isActive}
    >
      {children}
    </Link>
  </li>
)